import { API_STATUS } from 'core-lib/constants/network';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import getProductDescription from '../services/pdp/getProductDescription';
import { updatePdp } from '../store/action';
import { ProductDescriptionDataParent } from '../types';
import { ProductDescription } from '../types/product';
import useParkplusStoreV2 from './useParkplusStoreV2';
const useProductDescription = () => {
  //redux
  const {
    productDescriptions,
    productDescriptionData,
    productDescriptionDataApiStatus,
  } = useParkplusStoreV2();
  // declarations
  const dispatch = useDispatch();
  const router = useRouter();
  // constants
  const productId = router?.query?.productId ? +router.query.productId : 0;

  function updatePdpSlice(payload) {
    dispatch(updatePdp(payload));
  }
  //update pdp after api call
  const updatePdpAfterApiCall = (
    response: ProductDescription,
    payload: ProductDescriptionDataParent
  ) => {
    if (response) {
      payload = {
        ...payload,
        apiStatus: API_STATUS.success,
        data: {
          ...payload?.data,
          [productId]: response,
        },
      };
    } else {
      payload = {
        ...payload,
        apiStatus: API_STATUS.failure,
        data: {
          ...payload?.data,
        },
      };
    }
    updatePdpSlice(payload);
  };

  const fetchData = async () => {
    let payload: ProductDescriptionDataParent = {
      ...productDescriptions,
      data: productDescriptionData,
      apiStatus: API_STATUS.in_progress,
    };
    updatePdpSlice(payload);
    const response: ProductDescription = await getProductDescription(productId);
    updatePdpAfterApiCall(response, payload);

    //reverting to last successful pdp response
    if (!response && router?.query?.lastSuccessProductId) {
      const id = router?.query?.lastSuccessProductId;
      router.replace(
        {
          pathname: `${id}`,
        },
        null,
        { shallow: true }
      );
    }
  };

  useEffect(() => {
    if (productId) {
      fetchData();
    }
  }, [productId]);

  return {
    productDescriptionDataApiStatus,
    data: productDescriptionData[productId],
    updatePdpSlice,
  };
};
export default useProductDescription;
